export const systemLogsMessages = (item) => {
    return {
        "sys-logs-invalid-date-filter": "Invalid Start Date or End Date",
        "sys-logs-start-date-greater-than-end-date": "Start Date cannnot be greater than End Date",
        "sys-logs-api-failure": "Failed to Get the System Logs Data",
        "sys-logs-no-data-found": "No data found for selected filters."
    }
}